/**
 * "System" characters — the shared, admin-managed defaults (Уля the owl, Мурзик
 * the cat …) seeded into every family library from the admin character templates.
 *
 * They are identified by their deterministic seed id (`seed_<familyId>_tmpl_<x>`,
 * minted by seedCharactersFromTemplates), so no schema flag is needed. They must
 * NOT be user-deletable — only the admin console (character templates) manages
 * them — so both the delete action and the UI gate on this.
 */
export function isSystemCharacter(characterId: string | null | undefined): boolean {
  return !!characterId && /^seed_.+_tmpl_/.test(characterId);
}

/** The template a system character was seeded from (`seed_<family>_tmpl_x` → `tmpl_x`). */
export function systemTemplateId(characterId: string | null | undefined): string | null {
  const m = /^seed_.+_(tmpl_[a-z0-9_]+)$/i.exec(characterId ?? '');
  return m ? m[1] : null;
}

/**
 * The shared heroes carry one base name (Russian) plus a per-locale table, so a
 * German family sees "Murzik" rather than "Мурзик". Falls back to the base name
 * for a locale nobody has written yet.
 */
export function localizedTemplateName(
  template: { name: string; nameI18n?: Record<string, string> | null },
  locale: string | null | undefined,
): string {
  const lang = (locale ?? '').split('-')[0].toLowerCase();
  return (lang && template.nameI18n?.[lang]?.trim()) || template.name;
}
